import { currencyFormat } from './currencyFormat.js';
import { Product, Frequency } from '../../src/IxPricing.js';

interface Pricing {
  currency: string | undefined;
  total: {
    Monthly: number;
    OneTime: number;
  };
  products: {
    [key: string]: {
      quantity: number;
      Monthly: number;
      OneTime: number;
      name: string;
    };
  };
}

interface Price {
  amount: {
    unit: string;
    value: number;
  };
  frequency: Frequency;
}

export const transformPricingData = (data: Product[]) => {
  /* eslint-disable no-param-reassign */
  const { currency, total, products } = data.reduce<Pricing>(
    (pricing, item) => {
      const key = item.product.id;
      if (!pricing.products[key]) {
        pricing.products[key] = {
          quantity: 0,
          Monthly: 0,
          OneTime: 0,
          name: item.product.name,
        };
      }
      const product = pricing.products[key];
      product.quantity += 1;
      item.price_list.forEach((price: Price) => {
        if (!pricing.currency) {
          pricing.currency = price.amount.unit;
        }
        if (price.amount.unit !== pricing.currency) {
          throw new Error(
            `conflicting currencies: ${pricing.currency}, ${price.amount.unit}`
          );
        }
        const { frequency }: { frequency: 'Monthly' | 'OneTime' } = price;
        product[frequency] += price.amount.value;
        pricing.total[frequency] += price.amount.value;
      });
      return pricing;
    },
    {
      currency: undefined,
      total: {
        Monthly: 0,
        OneTime: 0,
      },
      products: {},
    }
  );
  return {
    total: {
      monthly: currencyFormat(currency, total.Monthly),
      oneTime: currencyFormat(currency, total.OneTime),
    },
    products: Object.values(products).map(product => ({
      ...product,
      monthly: currencyFormat(currency, product.Monthly),
      oneTime: currencyFormat(currency, product.OneTime),
    })),
  };
};
